/* SIZESOFTX
=========================================================================================
* Descripción: Sesión del panel de soporte en sessionStorage (muere al cerrar la pestaña).
* Antes el token vivía en localStorage y sobrevivía al cierre del navegador.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1        | 17/09/2026 | Muse Spark                       | Sesión en sessionStorage + limpieza legacy.
* ---------------------------------------------------------------------------------------
*/

const TOKEN_KEY = "support_token";
const USER_KEY = "support_user";
const LOGIN_AT_KEY = "support_login_at";
const LAST_ACTIVITY_KEY = "support_last_activity";

const safeGet = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (storage, key, value) => {
  try {
    storage.setItem(key, value);
  } catch {
    // almacenamiento no disponible (modo privado): la sesión solo vivirá en memoria
  }
};

const safeRemove = (storage, key) => {
  try {
    storage.removeItem(key);
  } catch {
    // ignorar
  }
};

/** Lee el token solo de sessionStorage. Cerrar la pestaña = sesión muerta. */
export const getSessionToken = () => safeGet(window.sessionStorage, TOKEN_KEY);

export const getSessionUser = () => {
  try {
    const raw = safeGet(window.sessionStorage, USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setSession = (token, user) => {
  const now = String(Date.now());
  safeSet(window.sessionStorage, TOKEN_KEY, token);
  safeSet(window.sessionStorage, USER_KEY, JSON.stringify(user || {}));
  safeSet(window.sessionStorage, LOGIN_AT_KEY, now);
  safeSet(window.sessionStorage, LAST_ACTIVITY_KEY, now);
};

export const clearSession = () => {
  [TOKEN_KEY, USER_KEY, LOGIN_AT_KEY, LAST_ACTIVITY_KEY].forEach((k) => {
    safeRemove(window.sessionStorage, k);
    safeRemove(window.localStorage, k); // limpieza legacy: antes se guardaba en localStorage
  });
};

export const touchActivity = () => {
  if (!getSessionToken()) return;
  safeSet(window.sessionStorage, LAST_ACTIVITY_KEY, String(Date.now()));
};

export const getLoginAt = () => Number(safeGet(window.sessionStorage, LOGIN_AT_KEY) || 0);

export const getLastActivity = () => Number(safeGet(window.sessionStorage, LAST_ACTIVITY_KEY) || 0);
